/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_DescriptionInputs */



/**
* | output |
* | --- |
* | "View and manage commit history snapshots" |
*
* @param {Snapshot_History_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_description = /** @type {((inputs?: Snapshot_History_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher et gerer l'historique des commits")
	if (locale === "de") return /** @type {LocalizedString} */ ("Commit-Verlauf-Snapshots anzeigen und verwalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza e gestisci gli snapshot della cronologia degli impegni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Просмотр и управление снимками истории коммитов.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver y administrar instantáneas del historial de confirmaciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("查看和管理提交历史快照")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コミット履歴のスナップショットを表示および管理する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कमिट हिस्ट्री स्नैपशॉट देखें और प्रबंधित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Visualize e gerencie snapshots do histórico de commits.")
	return /** @type {LocalizedString} */ ("View and manage commit history snapshots")
});